import React from 'react';

import styles from './Section.module.scss';

export interface Props {
  bgColor?: string;
  padded?: boolean;
}

const Section: React.FC<Props> = ({bgColor, padded, children}) => {
  return (
    <div
      style={{backgroundColor: bgColor}}
      className={`${styles.Section} ${padded && styles.padded}`}
    >
      {children}
    </div>
  );
};

export default Section;
